import {
  FeaturesEnum_en,
  HeroPillCategoryEnum_en,
  ProductsEnum_en,
} from "@/shared/data/hero-pills.data";
import {
  FeaturesEnum_kr,
  HeroPillCategoryEnum_kr,
  ProductsEnum_kr,
} from "@/shared/data/hero-pills.data.kr";
import { Typography } from "@graphy/ui";
import classNames from "classnames";

type HeroPillPropsType =
  | {
      category:
        | HeroPillCategoryEnum_en.Products
        | HeroPillCategoryEnum_kr.Products;
      subCategory: ProductsEnum_en | ProductsEnum_kr;
      className?: string;
    }
  | {
      category:
        | HeroPillCategoryEnum_en.Features
        | HeroPillCategoryEnum_kr.Features;
      subCategory: FeaturesEnum_en | FeaturesEnum_kr;
      className?: string;
    }
  | {
      category:
        | HeroPillCategoryEnum_en.Creators
        | HeroPillCategoryEnum_kr.Creators
        | HeroPillCategoryEnum_en.Pricing
        | HeroPillCategoryEnum_kr.Pricing
        | string;
      className?: string;
      textColor?: string;
    };

const HeroPill = (props: HeroPillPropsType) => {
  const { category } = props;

  if ("subCategory" in props && props.subCategory) {
    return (
      <div
        className={classNames(
          "relative inline-flex items-center overflow-hidden",
          props.className
        )}
      >
        <div
          className={classNames(" rounded-l-full bg-purple-0 py-1 pl-3 pr-1")}
        >
          <Typography
            size="CAPTION"
            colorClass="text-purple-3"
            fontWeight="font-semibold"
          >
            {category}
          </Typography>
        </div>
        <div className="relative overflow-hidden rounded-r-full bg-purple-3 py-1 pl-6 pr-3">
          <div className="absolute left-0 top-1/2 aspect-square h-[80%] -translate-x-1/2 -translate-y-1/2 rotate-45 rounded bg-purple-0"></div>
          <Typography
            size="CAPTION"
            colorClass="text-grey-0"
            fontWeight="font-semibold"
          >
            {props.subCategory}
          </Typography>
        </div>
      </div>
    );
  } else {
    return (
      <div
        className={classNames(
          "inline-flex items-center rounded-full bg-purple-3 px-3 py-1",
          props.className
        )}
      >
        <Typography
          size="CAPTION"
          colorClass={props.textColor ? props.textColor : "text-grey-0"}
          fontWeight="font-semibold"
        >
          {category}
        </Typography>
      </div>
    );
  }
};

export default HeroPill;
